module.exports = require('./helpers/bundle-url').getBundleURL('koVhS') + "cleverpenman-transparent.d879d2a2.webp";